import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import type { CreateDocumentInput, UpdateDocumentInput } from "@montatec/contracts"
import { CacheKeys } from "../../shared/consts/keys.consts"
import { documentsService } from "./documents.service"


export function useDocuments() {
    return useQuery({
        queryKey: CacheKeys.documents,
        queryFn: documentsService.get,
    })
}

export function useDocumentsMutations() {
    const qc = useQueryClient()
    
    const createDocument = useMutation({
        mutationFn: (data : CreateDocumentInput) => documentsService.create(data),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: CacheKeys.documents });
            qc.invalidateQueries({ queryKey: CacheKeys.categories })
        }
    })

    const updateDocument = useMutation({
        mutationFn: ({id, data} : {id: number, data: UpdateDocumentInput}) => documentsService.update(id, data),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: CacheKeys.documents });
            qc.invalidateQueries({ queryKey: CacheKeys.categories })
        }
    })
    
    const deleteDocument = useMutation({
        mutationFn: documentsService.delete,
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: CacheKeys.documents });
            qc.invalidateQueries({ queryKey: CacheKeys.categories })
        }
    })

    return { createDocument, updateDocument, deleteDocument }
}
